export const NavBarStyle = Object.freeze({
  TRANSPARENT: 'TRANSPARENT',
  DARK: 'DARK',
  LIGHT: 'LIGHT'
});
